import { derived, writable } from "svelte/store"
import { overlay } from "./OverlayStore";

const naturalSort = ( a, b ) =>
	a.title.toUpperCase() < b.title.toUpperCase() ? -1 : 1

// ---
// Locations : from wordpress via localize script.
// ---
export const allLocations = writable( [] )


// ---
// Regions : derived once.
// ---
export const regions = derived( allLocations, ( $allLocations ) => {

	const dict = $allLocations
		.map( l => l.state )
		.filter( state => state.parent == 0 )
		.reduce( ( acc, region ) => {
			acc[region.id] = { ...region }
			return acc
		}, {} )

	const regions = Object
		.values( dict )
		.sort( naturalSort )

	return regions
} )


// ---
// Context Locations : are visible if they have a "valid / truthy" context url defined.
// ---
export const contextLocations = derived( [ allLocations, overlay ], ( [ $allLocations, $overlay ] ) => {
	// guard : nothing visible so reset
	if ( ! $overlay.visible ) return []

	// guard : context must exist
	if ( ! $overlay.context ) return []

	// guard : context.id is set
	if ( ! $overlay.context.id ) return []

	// filter locations by whether or not the relevant context url is truthy
	const locations = $allLocations
		.filter( l => l.context_urls[$overlay.context.id] )

	return locations
} )
